<template>
  <div class="py-4 container-fluid">
    <form ref="createForm" class="needs-validation" novalidate>
      <div class="row">
        <div class="text-right col-lg-12 d-flex justify-content-end align-items-center">
          <div class="col-lg-1 p-0 text-start">
            <a
              class="p-0 back-button"
              style="cursor: pointer"
              :title="$t('key_button_back')"
              @click="$router.go(-1)">
              <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i>
            </a>
          </div>
          <div class="my-auto ms-auto">
            <button
              type="button"
              class="mb-0 me-2 btn btn-outline-success"
              data-bs-toggle="modal"
              data-bs-target="#addProductModal">
              <i class="fa-solid fa-plus me-2"></i>{{ $t('key_button_add_product') }}
            </button>
            <button type="button" class="mb-0 btn bg-gradient-success" @click="save()">
              {{ $t('key_button_save') }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-4 row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h5 class="font-weight-bolder">{{ $t('key_products') }}</h5>
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>{{ $t('key_theader_product') }}</th>
                      <th>{{ $t('key_theader_ean') }}</th>
                      <th>{{ $t('key_theader_batch') }}</th>
                      <th>{{ $t('key_theader_batch_date') }}</th>
                      <th>{{ $t('key_theader_warehouse') }}</th>
                      <th class="text-end">{{ $t('key_theader_units') }}</th>
                      <th class="text-end">{{ $t('key_theader_price') }}</th>
                      <th class="text-end">{{ $t('key_theader_tax') }}</th>
                      <th class="text-end">{{ $t('key_theader_total') }}</th>
                      <th>{{ $t('key_theader_actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="order.products.length === 0">
                      <td colspan="10" class="text-center text-sm text-secondary">{{ $t('key_products_empty') }}</td>
                    </tr>
                    <tr v-for="(product, index) in order.products" :key="index">
                      <td class="font-weight-bold"><span class="my-2 text-xs columns">{{ product.name }}</span></td>
                      <td class="font-weight-bold"><span class="my-2 text-xs columns">{{ product.ean }}</span></td>
                      <td class="font-weight-bold"><span class="my-2 text-xs columns">{{ product.batch }}</span></td>
                      <td class="font-weight-bold"><span class="my-2 text-xs columns">{{ product.batch_date }}</span></td>
                      <td class="font-weight-bold"><span class="my-2 text-xs columns">{{ product.warehouse }}</span></td>
                      <td class="text-end text-xs font-weight-bold">{{ product.units.requested }}</td>
                      <td class="text-end text-xs font-weight-bold">{{ $numberFormat.toCurrency(product.price) }}</td>
                      <td class="text-end text-xs font-weight-bold">{{ $numberFormat.toCurrency(product.tax) }}</td>
                      <td class="text-end text-xs font-weight-bold">{{ $numberFormat.toCurrency(product.total) }}</td>
                      <td class="text-sm">
                        <a class="mx-3" style="cursor:pointer" :title="$t('key_edit')" data-bs-toggle="modal" data-bs-target="#updateProductModal" @click="editProduct(product, index)">
                          <i class="fas fa-edit text-secondary"></i>
                        </a>
                        <a class="mx-3" style="cursor:pointer" :title="$t('key_delete')" @click="removeProduct(index)">
                          <i class="fas fa-trash text-danger"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="order.products.length > 0">
                    <tr class="border-top border-primary">
                      <td colspan="6" class="text-start text-uppercase text-primary border-bottom-0 totals-label">{{ $t('key_order_totals') }}</td>
                      <td class="text-end text-xs font-weight-bold border-bottom-0">{{ $numberFormat.toCurrency(productTotals.amount) }}</td>
                      <td class="text-end text-xs font-weight-bold border-bottom-0">{{ $numberFormat.toCurrency(productTotals.tax) }}</td>
                      <td class="text-end border-bottom-0 totals-value">{{ $numberFormat.toCurrency(productTotals.total) }}</td>
                      <td class="border-bottom-0"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 row">
        <div class="col-lg-5 mt-lg-0">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="font-weight-bolder">{{ $t('key_title_order_details') }}</h5>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_order_code') }} <span style="color:red">*</span> </label>
                  <input v-model="order.number" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_order_code')" required/>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_reference') }}</label>
                  <input v-model="order.reference" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_reference')"/>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_order_date') }} <span style="color:red">*</span> </label>
                  <input v-model="order.date" class="form-control" type="date" required/>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_carrier') }} <span style="color:red">*</span> </label>
                  <hk-select v-model="order.courier" :placeholder="$t('key_placeholder_carrier')" :options="courierOptions" required></hk-select>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_service') }} <span v-if="!serviceNotNeeded" style="color:red">*</span> </label>
                  <hk-select v-model="order.service" :placeholder="$t('key_placeholder_service')" :options="serviceOptions" :disabled="serviceDisabled" required></hk-select>
                  <small v-if="serviceNotNeeded" class="text-muted">{{ $t('key_message_service_not_needed') }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_shipping_method') }}</label>
                  <hk-select v-model="order.payment_method" :placeholder="$t('key_placeholder_shipping_method')" :options="shippingMethodOptions" :disabled="shippingMethodDisabled"></hk-select>
                  <small v-if="shippingMethodNotNeeded" class="text-muted">{{ $t('key_message_shipping_method_not_needed') }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_order_type') }} <span style="color:red">*</span> </label>
                  <hk-select v-model="order.type" :placeholder="$t('key_placeholder_order_type')" :options="orderTypeOptions" required></hk-select>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_logistic_instructions') }}</label>
                  <textarea v-model="order.internal_comment" class="form-control" rows="3" :placeholder="$t('key_placeholder_logistic_instructions')"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="text-primary">{{ $t('key_title_external_observations') }}</label>
                  <textarea v-model="order.external_observations" class="form-control" rows="3" :placeholder="$t('key_placeholder_external_observations')"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 mt-lg-0 col-lg-7">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="font-weight-bolder"><i class="far fa-user me-2"></i>{{ $t('key_customer_information') }}</h5>
              <ul class="nav nav-tabs customer-tabs">
                <li class="nav-item">
                  <button
                    type="button"
                    class="nav-link"
                    :class="{ active: activeCustomerTab === 'customer' }"
                    @click="activeCustomerTab = 'customer'">
                    {{ $t('key_tab_customer_details') }}
                  </button>
                </li>
                <li class="nav-item">
                  <button
                    type="button"
                    class="nav-link"
                    :class="{ active: activeCustomerTab === 'billing', disabled: order.same_as_end_customer }"
                    @click="!order.same_as_end_customer && (activeCustomerTab = 'billing')">
                    {{ $t('key_tab_billing_information') }}
                  </button>
                </li>
              </ul>
              <div v-show="activeCustomerTab === 'customer'">
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_customer') }} <span style="color:red">*</span> </label>
                    <input v-model="order.end_customer.name" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_customer')" required/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                    <label class="text-primary">{{ $t('key_title_contact_name') }}</label>
                    <input v-model="order.end_customer.contact" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_contact_name')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_vat_number') }}</label>
                    <input v-model="order.end_customer.vat" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_vat_number')"/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_phone') }}</label>
                    <input v-model="order.end_customer.phone" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_phone')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12">
                    <label class="text-primary">{{ $t('key_title_email') }} <span style="color:red">*</span> </label>
                    <input v-model="order.end_customer.email" class="form-control" type="email" maxLength="50" :placeholder="$t('key_placeholder_email')" required/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12">
                    <label class="text-primary">{{ $t('key_title_customer_address') }} <span style="color:red">*</span> </label>
                    <input v-model="order.end_customer.address.street" class="form-control" type="text" maxLength="100" :placeholder="$t('key_placeholder_customer_address')" required/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_postal_code') }} <span style="color:red">*</span> </label>
                    <input v-model="order.end_customer.address.postal_code" class="form-control" type="text" maxLength="20" :placeholder="$t('key_placeholder_postal_code')" required/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_city') }} <span style="color:red">*</span> </label>
                    <input v-model="order.end_customer.address.town" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_city')" required/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_province') }} <span style="color:red">*</span> </label>
                    <input v-model="order.end_customer.address.province" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_province')" required/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_country') }} <span style="color:red">*</span> </label>
                    <hk-select v-model="order.end_customer.address.country" :placeholder="$t('key_placeholder_country')" :options="countryOptions" required></hk-select>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12">
                    <div class="form-check">
                      <input id="sameAsEndCustomer" v-model="order.same_as_end_customer" class="form-check-input" type="checkbox">
                      <label class="form-check-label" for="sameAsEndCustomer">{{ $t('key_checkbox_same_as_end_customer') }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeCustomerTab === 'billing'">
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_billing_name') }} <span style="color:red">*</span> </label>
                    <input v-model="order.billing_address.name" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_billing_name')"/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                    <label class="text-primary">{{ $t('key_title_contact_name') }}</label>
                    <input v-model="order.billing_address.contact" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_contact_name')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_vat_number') }}</label>
                    <input v-model="order.billing_address.vat" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_vat_number')"/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_phone') }}</label>
                    <input v-model="order.billing_address.phone" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_phone')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12">
                    <label class="text-primary">{{ $t('key_title_email') }} <span style="color:red">*</span> </label>
                    <input v-model="order.billing_address.email" class="form-control" type="email" maxLength="50" :placeholder="$t('key_placeholder_email')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12">
                    <label class="text-primary">{{ $t('key_title_customer_address') }} <span style="color:red">*</span> </label>
                    <input v-model="order.billing_address.address.street" class="form-control" type="text" maxLength="100" :placeholder="$t('key_placeholder_customer_address')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_postal_code') }} <span style="color:red">*</span> </label>
                    <input v-model="order.billing_address.address.postal_code" class="form-control" type="text" maxLength="20" :placeholder="$t('key_placeholder_postal_code')"/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_city') }} <span style="color:red">*</span> </label>
                    <input v-model="order.billing_address.address.town" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_city')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_province') }} <span style="color:red">*</span> </label>
                    <input v-model="order.billing_address.address.province" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_province')"/>
                  </div>
                  <div class="mt-3 col-12 col-sm-6">
                    <label class="text-primary">{{ $t('key_title_country') }} <span style="color:red">*</span> </label>
                    <hk-select v-model="order.billing_address.address.country" :placeholder="$t('key_placeholder_country')" :options="countryOptions"></hk-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <AddProductModal :warehouse-options="warehouseOptions" @product-added="addProduct" />
    <UpdateProductModal :warehouse-options="warehouseOptions" :product="productToEdit" :index="productToEditIndex" @product-updated="updateProduct" />
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>
</template>

<script>
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import AddProductModal from "@/components/AddProductModal.vue";
import UpdateProductModal from "@/components/UpdateProductModal.vue";
import HkSelect from "@/hotaka/components/HkSelect.vue";
import { orderOrigin } from "@/globalVars";

export default {
  name: "CreateOrder",
  components: { SoftSnackbar, AddProductModal, UpdateProductModal, HkSelect },
  data() {
    return {
      order: {
        number: '',
        reference: '',
        date: '',
        courier: '',
        service: '',
        payment_method: '',
        external_observations: '',
        internal_comment: '',
        origin: orderOrigin,
        type: '',
        same_as_end_customer: true,
        end_customer: {
          name: '',
          contact: '',
          vat: '',
          phone: '',
          email: '',
          address: {
            street: '',
            postal_code: '',
            town: '',
            province: '',
            country: ''
          }
        },
        billing_address: {
          name: '',
          contact: '',
          vat: '',
          phone: '',
          email: '',
          address: {
            street: '',
            postal_code: '',
            town: '',
            province: '',
            country: ''
          }
        },
        products: []
      },
      activeCustomerTab: 'customer',
      productToEdit: {},
      productToEditIndex: -1,
      countryOptions: [],
      courierOptions: [],
      serviceOptions: [],
      serviceNotNeeded: false,
      shippingMethodOptions: [],
      shippingMethodNotNeeded: false,
      orderTypeOptions: [],
      warehouseOptions: [],
      notificationInfo: {
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false
    }
  },
  computed: {
    newOrderStatus() {
      return this.$store.state.order.newOrder.data;
    },
    paises() {
      return this.$store.state.paises.list.data;
    },
    couriers() {
      return this.$store.state.couriers.list.data;
    },
    courierServices() {
      return this.$store.state.courierServices.list.data;
    },
    serviceDisabled() {
      return !this.order.courier || this.serviceNotNeeded;
    },
    courierShippingMethods() {
      return this.$store.state.courierShippingMethods.list.data;
    },
    shippingMethodDisabled() {
      return !this.order.courier || this.shippingMethodNotNeeded;
    },
    orderTypes() {
      return this.$store.state.orderTypes.list.data;
    },
    warehouses() {
      return this.$store.state.warehouse.options.data;
    },
    productTotals() {
      return this.order.products.reduce((acc, product) => {
        acc.amount += product.amount || 0;
        acc.tax += product.tax || 0;
        acc.total += product.total || 0;
        return acc;
      }, { amount: 0, tax: 0, total: 0 });
    }
  },
  watch: {
    newOrderStatus(newValue) {
      if (newValue) {
        this.loadStatusNotification(newValue);
      } else if (this.$store.state.order.newOrder.error) {
        this.notificationInfo = {
          title: this.$t('key_mheader_order_error'),
          message: this.$t('key_mmessage_order_saving_error'),
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
    paises(values) {
      if (values) {
        let elements = [];
        for (let pais of values.items) {
          elements.push({
            value: pais.code,
            label: pais.name
          })
        }
        this.countryOptions = elements.sort((a, b) => a.label.localeCompare(b.label));
      }
    },
    couriers(values) {
      if (values) {
        this.courierOptions = values.map(courier => ({
          value: courier.key,
          label: courier.label
        })).sort((a, b) => a.label.localeCompare(b.label));
      }
    },
    'order.courier'(newValue, oldValue) {
      if (!newValue) {
        this.serviceOptions = [];
        this.serviceNotNeeded = false;
        this.order.service = '';
        this.shippingMethodOptions = [];
        this.shippingMethodNotNeeded = false;
        this.order.payment_method = '';
        return;
      }
      if (oldValue) {
        this.order.service = '';
        this.order.payment_method = '';
      }
      this.$store.commit('courierServices/load', newValue);
      this.$store.commit('courierShippingMethods/load', newValue);
    },
    courierServices(values) {
      const state = this.$store.state.courierServices.list;
      if (values && state.courier === this.order.courier) {
        if (values.length === 0) {
          this.serviceOptions = [];
          this.serviceNotNeeded = true;
          this.order.service = '';
        } else {
          this.serviceNotNeeded = false;
          this.serviceOptions = values.map(service => ({
            value: service.key,
            label: service.label
          })).sort((a, b) => a.label.localeCompare(b.label));
        }
      }
    },
    courierShippingMethods(values) {
      const state = this.$store.state.courierShippingMethods.list;
      if (values && state.courier === this.order.courier) {
        if (values.length === 0) {
          this.shippingMethodOptions = [];
          this.shippingMethodNotNeeded = true;
          this.order.payment_method = '';
        } else {
          this.shippingMethodNotNeeded = false;
          this.shippingMethodOptions = values.map(method => ({
            value: method.key,
            label: method.label
          })).sort((a, b) => a.label.localeCompare(b.label));
        }
      }
    },
    orderTypes(values) {
      if (values) {
        this.orderTypeOptions = [...values]
          .sort((a, b) => a.weight - b.weight)
          .map(orderType => ({
            value: orderType.key,
            label: orderType.label
          }));
      }
    },
    warehouses(values) {
      if (values) {
        this.warehouseOptions = values.map(warehouse => ({
          value: warehouse.key,
          label: warehouse.label
        })).sort((a, b) => a.label.localeCompare(b.label));
      }
    },
    'order.same_as_end_customer'(newValue) {
      if (newValue) {
        this.activeCustomerTab = 'customer';
      }
    }
  },
  mounted() {
    this.$store.commit("paises/load");
    this.$store.commit("couriers/load");
    this.$store.commit("orderTypes/load");
    this.$store.dispatch(this.$PickoVersion.isV2() ? "warehouse/getAllWarehousesV2" : "warehouse/getAllWarehouses");
  },
  methods: {
    addProduct(product) {
      this.order.products.push(product);
    },
    editProduct(product, index) {
      this.productToEdit = { ...product };
      this.productToEditIndex = index;
    },
    updateProduct({ index, product }) {
      this.order.products.splice(index, 1, product);
    },
    removeProduct(index) {
      this.order.products.splice(index, 1);
    },
    isBillingAddressValid() {
      const billingAddress = this.order.billing_address;
      return !!(
        billingAddress.name &&
        billingAddress.email &&
        billingAddress.address.street &&
        billingAddress.address.postal_code &&
        billingAddress.address.town &&
        billingAddress.address.province &&
        billingAddress.address.country
      );
    },
    save() {
      let form = this.$refs.createForm;
      if (form.checkValidity()) {
        if (this.order.products.length === 0) {
          this.notificationInfo = {
            title: this.$t('key_mheader_order_products_warning'),
            message: this.$t('key_mmessage_order_products_required'),
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotification();
          return
        }
        if (!this.order.same_as_end_customer && !this.isBillingAddressValid()) {
          this.activeCustomerTab = 'billing';
          this.notificationInfo = {
            title: this.$t('key_mheader_order_billing_warning'),
            message: this.$t('key_mmessage_order_billing_required'),
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotification();
          return
        }
        this.order.amount = this.productTotals.amount;
        this.order.tax = this.productTotals.tax;
        this.order.total = this.productTotals.total;
        const payload = { ...this.order, origin: orderOrigin };
        if (payload.same_as_end_customer) {
          delete payload.billing_address;
        }
        this.$store.commit("order/newOrder", payload);
      }
      form.classList.add('was-validated');
    },
    closeNotificationAndRedirect() {
      const self = this;
      setTimeout(function () {
        self.$router.push({ name: "Orders list" });
      }, 1050);
    },
    closeNotification() {
      const self = this;
      setTimeout(function () {
        self.showNotification = false
      }, 1300);
    },
    loadStatusNotification(value) {
      if (value.status == 'KO') {
        this.notificationInfo = {
          title: this.$t('key_mheader_order_error'),
          message: value.data.error,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      } else {
        this.notificationInfo = {
          title: this.$t('key_mheader_order_ok'),
          message: this.$t('key_mmessage_order_ok'),
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotificationAndRedirect();
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.back-button {
  color: #4A7062
}

.totals-label {
  font-weight: 800;
}

.totals-value {
  font-weight: 800;
  font-size: 16px;
}

.customer-tabs {
  margin-bottom: 1rem;

  .nav-link {
    cursor: pointer;
    color: #8a98a8;
    font-weight: 700;
    border: none;
    border-bottom: 2px solid transparent;

    &:hover {
      color: #4A7062;
    }

    &.active {
      color: #4A7062;
      border-bottom-color: #4A7062;
      background: none;
    }

    &.disabled {
      color: #c2ccc7;
      cursor: not-allowed;
    }

    &.disabled:hover {
      color: #c2ccc7;
    }
  }
}

</style>
